import { useEffect, useState } from "react";
import { workerTutorialRole } from "./tutorialLanguages";

export const VIDEO_LIBRARY_PATH = "/managementusa/Videos";
export const PUBLIC_VIDEO_BRAND = "BUNGALOW PORTAL";
const API = `${process.env.REACT_APP_BACKEND_URL}/api/public/management-videos`;
export const videoPath = item => `${VIDEO_LIBRARY_PATH}/${encodeURIComponent(item.audience)}/${encodeURIComponent(item.section)}`;
export const videoShareUrl = item => new URL(videoPath(item), window.location.origin).href;
export const videoSource = item => `${API}/${encodeURIComponent(item.audience)}/${encodeURIComponent(item.section)}/video?revision=${encodeURIComponent(item.revision)}`;
export const videoGroup = item => item.audience === "worker" && workerTutorialRole(item.section) === "manager" ? "manager" : item.audience;
export const VIDEO_GROUPS = { admin: "Admin", colony: "Colony", worker: "Worker", manager: "Worker manager" };
export const videoDuration = seconds => {
  if (seconds == null) return "Video";
  const total = Math.max(0, Math.floor(seconds));
  return total >= 3600 ? `${Math.floor(total / 3600)}:${String(Math.floor(total / 60) % 60).padStart(2, "0")}:${String(total % 60).padStart(2, "0")}`
    : `${Math.floor(total / 60)}:${String(total % 60).padStart(2, "0")}`;
};

export const usePublicVideos = (audience, section) => {
  const path = audience && section ? `/${encodeURIComponent(audience)}/${encodeURIComponent(section)}` : "";
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState({ data: null, loading: true, error: "", missing: false });
  useEffect(() => {
    const controller = new AbortController();
    setState({ data: null, loading: true, error: "", missing: false });
    (async () => {
      try {
        const response = await fetch(`${API}${path}`, { credentials: "omit", cache: "no-store", signal: controller.signal });
        if (!response.ok) throw Object.assign(new Error("Could not load videos. Please try again."), { status: response.status });
        const data = await response.json();
        if (!controller.signal.aborted) setState({ data, loading: false, error: "", missing: false });
      } catch (error) {
        if (!controller.signal.aborted) setState({ data: null, loading: false, error: "Could not load videos. Please try again.", missing: [404, 422].includes(error.status) });
      }
    })();
    return () => controller.abort();
  }, [path, attempt]);
  return { ...state, reload: () => setAttempt(value => value + 1) };
};